<template>
  <div v-if="data">
    <form  autocomplete="off">

      <div class="row">
       <div class="col-md-12">
           <btn-rounded
        label="Aprovar"
        event="executeApprove"
        activeColor="success"

      />
        <btn-rounded
        label="Rejeitar"
        event="executeReject"
        activeColor="danger"
      />
       </div>
      <div class="col-md-12">
        <!-- EDIT USER -->
        <h4 class="input-group-title">
          Dados do usuário
        </h4>
      </div>


         <div
          class="col-md-3"
        >
          <span style="font-size: 16px"> Foto do usuário</span>
          <form-group-image
            :url="null"
            :value="data.imageURL"
            img-type="square"
          />
        </div>
        
           <div
          class="col-md-5"
        >
          <span style="font-size: 16px"> Foto do contra-cheque </span>
          <form-group-image
            :url="null"
            :value="data.Salaries.length > 0?data.Salaries[0].imageURL:''"
            img-type="landscape"
          />
        </div>
        
      <div class="col-md-6">
          <fg-input class="clean" type="text" label="Salario" placeholder="R$ 0,00" :value="data.Salaries.length > 0? data.Salaries[0].formattedValueCentavos:''"
            v-bind:readonly="readonly" />
        </div>

        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Cobrança" placeholder="" :value="data.charge"
            v-bind:readonly="readonly" />
        </div>

      <div class="col-md-12 no-padding">
          <div class="col-md-6">
          <fg-input class="clean" type="email" label="E-mail" placeholder="carlos.andrade@gmail.com" v-model="data.email"
            v-bind:readonly="readonly" />
        </div>
        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Nome Completo" placeholder="Carlos" v-model="data.name"
            v-bind:readonly="readonly" />
        </div>

        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Instagram" placeholder="" 
            v-model="data.instagram" v-bind:readonly="readonly" />
        </div>

        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Matrícula Sindsep" placeholder="" 
            v-model="data.sindsepRegistration" v-bind:readonly="readonly" />
        </div>

        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Registro Siape" placeholder="" 
            v-model="data.siapeRegistration" v-bind:readonly="readonly" />
        </div>

        
        <div class="col-md-6">
          <fg-input class="clean" type="text" label="RG" placeholder="" 
            v-model="data.rg" v-bind:readonly="readonly" v-mask="'#######'" />
        </div>

         <div class="col-md-6">
          <fg-input class="clean" type="text" label="CPF" placeholder="" 
            v-model="data.cpf" v-bind:readonly="readonly"  v-mask="'###.###.###-##'"/>

        </div>

        
        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Data de Nascimento" placeholder="  /  /    " v-mask="'##/##/####'"
            v-model="data.birthday" v-bind:readonly="readonly" />
        </div>

        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Telefone" placeholder="(  )      -     " v-mask="'(##) #####-####'"
            v-model="data.formattedPhone" v-bind:readonly="readonly" />
        </div>

    
         <div class="col-md-3">
            <fg-select
              :options="civilstateList"
              v-model="data.CivilStateId"
              :selected="data.CivilStateId"
              label="Estado Civil"
              v-bind:readonly="readonly"
            />
          </div>

           <div class="col-md-3">
            <fg-select
              :options="sexList"
              v-model="data.SexId"
              :selected="data.SexId"
              label="Sexo"
              v-bind:readonly="readonly"
            />
          </div>

           <div class="col-md-3">
            <fg-select
              :options="nationalityList"
              v-model="data.NationalityId"
              :selected="data.NationalityId"
              label="Nacionalidade"
              v-bind:readonly="readonly"
            />
          </div>

            <div class="col-md-3">
            <fg-select
              :options="organList"
              v-model="data.OrganId"
              :selected="data.OrganId"
              label="Orgão"
              v-bind:readonly="readonly"
            />
          </div>


        <!-- <div class="col-md-6">
          <label class="stronger" style="margin: 0px !important"> Ativo? </label> <br>
            <button
                class="btn btn-rounded btn-fill btn-wd"
                :class="data.isActive?'btn-success':'btn-danger'"
                style="margin-top: 5px !important"
                v-on:click="checkIsActive(data.isActive)"
              >
              <font v-if="data.isActive"> Ativo </font>
              <font v-if="!data.isActive"> Não Ativo </font>

              </button>
        </div> -->
          

            <div class="col-md-6">
            <fg-select
              :options="situationList"
              v-model="data.situation"
              :selected="data.situation"
              label="Situação"
              v-bind:readonly="readonly"
            />
          </div>

        <!-- <h5 class="input-group-title" v-if="edit && !readonly">
          Alterar Senha
        </h5>
        <div class="col-md-6" v-if="!readonly">
          <fg-input type="password" label="Senha" placeholder="Senha" v-model="data.password" />
        </div>
        <div class="col-md-6" v-if="!readonly">
          <fg-input type="password" label="Confirmar Senha" placeholder="Senha" v-model="data.confirmPassword" />
        </div> -->

      </div>
      </div>

        <div class="row" v-if="data.CardIdDefault != null">
           <div class="col-md-12">
        <!-- EDIT USER -->
        <h4 class="input-group-title">
          Dados do cartão
        </h4>
      </div>
         <div class="col-md-12">
        <credit-card-form
          :data='card'
          :readonly="readonly"
        />
      </div>
    </div>

    <div class="row">
         <div class="col-md-12">
        <client-address-form
          :data='data'
          :readonly="readonly"
        />
      </div>
    </div>

  <!-- <div class="text-right">
      <btn-rounded
        v-if="!readonly"
        label="SALVAR"
        event="execute"
      />
    </div> -->
    </form>

  </div>
</template>

<script>
  import {
    mapActions,
    mapState,
    mapGetters
  } from "vuex";
  import moment from 'moment';
  import ClientAddressForm from "components/UIComponents/Forms/ClientAddressForm.vue";
  import CreditCardForm from "components/UIComponents/Forms/CreditCardForm.vue";
  import ClientCard from 'components/UIComponents/Cards/ClientCard.vue'
  import formGroupImage from 'src/components/UIComponents/Inputs/formGroupImage.vue';

  export default {
    name: "user-form",
    components: {
      ClientAddressForm,
      ClientCard,
      formGroupImage,
      CreditCardForm
    },

    props: {
      data: {
        type: Object,
      },
      readonly: {
        type: Boolean,
        default: false
      },
      event: {
        type: String,
        default: ''
      },
       eventApprove: {
        type: String,
        default: ''
      },
       eventReject: {
        type: String,
        default: ''
      },
      edit: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState({
        civilstateList: ({
          civilstate
        }) => civilstate.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id
          }
        }),
        sexList: ({
          sex
        }) => sex.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id
          }
        }),
        nationalityList: ({
          nationality
        }) => nationality.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id
          }
        }),
        organList: ({
          organ
        }) => organ.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id
          }
        }),
      })
    },

    methods: {
      ...mapActions(["getCivilStateList", "getSexList", "getNationalityList", "getOrganList"]),
      ...mapGetters({
        sidebarFlag: 'sidebarFlag'
      }),
    
      getInvitedByURL(invited) {
        if (!invited) return '';
        let path = window.location.pathname === '/' ? '' : window.location.pathname;
        return `${path}/?#/admin/usuarios/editar/${invited.sharingCode}`;
      },
      formatDate(date) {
        return moment.utc(date).utcOffset(0).format('DD/MM/YYYY HH:mm:ss')
      },

      checkIsActive(situation){
        this.data.isActive = !situation
      },

      getCard(CardIdDefault){
        for(var i=0; i < this.data.UserCreditCards.length; i++){
          if(CardIdDefault == this.data.UserCreditCards[i].id){
            this.card =  this.data.UserCreditCards[i]
            return
          }
        }
      },

        initData(){
          if(this.data.situation == undefined){
            this.data.situation = 1
          }
          this.getCivilStateList().then(res=>{
            this.getSexList().then(res=>{
              this.getNationalityList().then(res=>{
                this.getOrganList()
                if(this.data.CardIdDefault != null){
                this.getCard(this.data.CardIdDefault)
                }
              })
            })
          })
        },


      // execute() {
      //   console.log("x")
      //   if (this.event) {
          

      //     this.$parent.$emit(this.event, this.data);
      //   }
      // },
    },

    created() {
      this.initData()

       this.$on("executeApprove", () => {
         if(this.eventApprove != ""){
            this.$parent.$emit(this.eventApprove, this.data);
         }

       }),

      this.$on("executeReject", () => {
          if(this.eventReject != ""){
            this.$parent.$emit(this.eventReject, this.data);
         }
       }),

      this.$on("execute", () => {

        if(this.event){
        let er = /^[a-zA-Z0-9][a-zA-Z0-9\._-]+@([a-zA-Z0-9\._-]+\.)[a-zA-Z-0-9]{2}/;

        if (!er.exec(this.data.email)) {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo E-mail inválido",
                position: "top center",
                type: "warn"
              });
        }

         if (!this.data.email || this.data.email == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo E-mail é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if(!this.data.name || this.data.name == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Nome é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if(!this.data.sindsepRegistration || this.data.sindsepRegistration == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Matrícula Sindsep é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

         if(!this.data.siapeRegistration || this.data.siapeRegistration == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Registro Siape é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

         if(!this.data.rg || this.data.rg == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo RG siape é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

         if(!this.data.cpf || this.data.cpf == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo CPF siape é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

   if (!this.data.formattedPhone || this.data.formattedPhone == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Telefone é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

         if (!this.data.birthday || this.data.birthday == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Data de Nascimento é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

          if (!this.data.CivilStateId || this.data.CivilStateId == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Estado Civil é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

         if (!this.data.SexId || this.data.SexId == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Sexo é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

         if (!this.data.NationalityId || this.data.NationalityId == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Nacionalidade é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

         if (!this.data.OrganId || this.data.OrganId == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Orgão é obrigatório",
                position: "top center",
                type: "warn"
              });
        }



// VALIDADE ADDRESS

        if (!this.data.address_cep || this.data.address_cep == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Cep é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if (!this.data.address_street || this.data.address_street == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Rua é obrigatório",
                position: "top center",
                type: "warn"
              });
        }


         if (!this.data.address_number || this.data.address_number  == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Número do endereço é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if (!this.data.address_district || this.data.address_district == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Bairro é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if (!this.data.address_city || this.data.address_city == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Cidade é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if (!this.data.address_abbreviation || this.data.address_abbreviation == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Estado é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

          if (!this.data.address_complement || this.data.address_complement  == "") {
             return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Complemento é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        this.$parent.$emit(this.event, this.data);

        }
      });

    },
    data() {
      return {
        localReadonly: false,
        card: {
          "id": "",
          "card_cvv": "",
          "card_expiration": "",
          "card_number": "",
          "holder_name": "",
          "imageURL": "",
          "last_four": "",
          "registry_code": "",
        },
        situationList: [
          {
          "name": "Indefinido",
          "value": -1
          },
           {
          "name": "Ativo",
          "value": 0
          },
           {
          "name": "Aposentado",
          "value": 1
          },
           {
          "name": "Pensionista",
          "value": 2
          },
        ]
      };
    },

  };
</script>

<style scoped lang="scss">

label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/AprovationForm.vue